var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 38.4,
    viewBox: "0 0 40 38.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162497",
    "data-name": "Group 162497",
    transform: "translate(-318 -542.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M21.884,1.335A6.351,6.351,0,0,1,28.865,3.61l.028.037A6.351,6.351,0,0,0,31.915,5.86l.057.02a6.351,6.351,0,0,1,4.277,5.9l0,.136a6.351,6.351,0,0,0,1.139,3.532l.082.118a6.351,6.351,0,0,1,0,7.259l-.082.118a6.351,6.351,0,0,0-1.139,3.532l0,.136a6.351,6.351,0,0,1-4.277,5.9l-.057.02a6.351,6.351,0,0,0-3.023,2.213l-.028.037a6.351,6.351,0,0,1-6.981,2.275h0a6.351,6.351,0,0,0-3.768,0h0a6.351,6.351,0,0,1-6.981-2.275l-.028-.037A6.351,6.351,0,0,0,8.085,32.54l-.057-.02a6.351,6.351,0,0,1-4.277-5.9l0-.136A6.351,6.351,0,0,0,2.61,22.948l-.082-.118a6.351,6.351,0,0,1,0-7.259l.082-.118a6.351,6.351,0,0,0,1.139-3.532l0-.136a6.351,6.351,0,0,1,4.277-5.9l.057-.02a6.351,6.351,0,0,0,3.023-2.213l.028-.037a6.351,6.351,0,0,1,6.981-2.275h0a6.351,6.351,0,0,0,3.768,0Z",
    transform: "translate(318 542.5)",
    fill: "#459f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_check_24px",
    d: "M9.766,17.62,5.025,12.878l-1.615,1.6,6.356,6.356L23.41,7.193l-1.6-1.6Z",
    transform: "translate(324.548 548.273)",
    fill: "#fdfdfd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.ea1fbec109ffd199c86a6b5fa4dff4f6.svg";
export { ForwardRef as ReactComponent };